// extracted by mini-css-extract-plugin
export default {"links":"Nav_links__CTxp-","linkContainer":"Nav_linkContainer__A5I7S","fade-blur":"Nav_fade-blur__komwc"};